import { render } from "./EngagementPosts.vue?vue&type=template&id=b15aef3a"
import script from "./EngagementPosts.vue?vue&type=script&lang=js"
export * from "./EngagementPosts.vue?vue&type=script&lang=js"

import "./EngagementPosts.vue?vue&type=style&index=0&id=b15aef3a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__